// windows.store.ts
import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { FinalProductWindows } from 'src/app/models/final_product_windows.model';



export interface WindowsState extends EntityState<FinalProductWindows> {
  finalProductId?: number;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'windows' })
export class WindowsStore extends EntityStore<WindowsState, FinalProductWindows> {
  constructor() {
    super();
  }
}
